import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import "styles/global.css"

const SignUp: React.FC = () => {
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [agreeCheck, setAgreeCheck] = useState<boolean>(false);

  const [error, setError] = useState<string>('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSignUp = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    var payload = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      password: password,
      agreeCheck: agreeCheck
    }
    // const authService = AuthService();
    // try {
    //   const res = await authService.login(username, password);
    //   console.log('Login Successful', res.data);
    //   dispatch(loginSuccess({ token: res.data.token, profile: res.data }))
    //   navigate('/dashboard');
    // } catch (error) {
    //   alert(error)
    //   setError('Login failed. Please check your credentials.');
    // }
  };

  return (
    <div className='container-fluid' style={{ padding: 0, height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className='row h-100'>
        <div className='col-md-6'>
          <img className="h-100 w-100" style={{ objectFit: 'cover' }} src='https://i.ytimg.com/vi/VPr58PX6NDU/sddefault.jpg' />
        </div>
        <div className='col-md-6'>
          <form onSubmit={handleSignUp} style={{ padding: 128 }}>
            <h1>Create an account</h1>
            <p>Already have an account? <Link to={"/signin"}>Sign in</Link></p>
            <br />
            <div className='row'>
              <div className='col-sm-6 pb-3'>
                <input id='firstName' name='firstName' type='text' className='form-control' placeholder='First name' onChange={(e)=> setFirstName(e.target.value)} required/>
              </div>
              <div className='col-sm-6 pb-3'>
                <input id='lastName' name='lastName' type='text' className='form-control' placeholder='Last name' onChange={(e) => setLastName(e.target.value)} required/>
              </div>
              <div className='col-sm-12 pb-3'>
                <input id='email' name='email' type='email' className='form-control' placeholder='Email' onChange={(e) => setEmail(e.target.value)} required/>
              </div>
              <div className='col-sm-12 pb-3'>
                <input id='password' name='password' type='password' className='form-control' placeholder='Password' onChange={(e) => setPassword(e.target.value)} required/>
              </div>
              <div className='col-sm-12 pb-3'>
                <input id='agreeCheck' name='agreeCheck' type='checkbox' checked={agreeCheck} onChange={(e) => setAgreeCheck(!agreeCheck)} required/> i agree to the <Link to={"/questionnaire/create"}>Terms & Conditions</Link>
                <br /><br />
              </div>
              <div className='col-sm-12 pb-3 text-center'>
                <button type='submit' id='createAccountButton' name='createAccountButton' className='btn btn-primary w-100'>Create account</button>
              </div>
              <div className='col-sm-12 pb-3 text-center'>
                <div className='d-flex'>
                  <hr className='w-100' />
                  <span className='d-flex align-items-center justify-content-center px-2' style={{whiteSpace:'nowrap'}}>Or register with</span>
                  <hr className='w-100' />
                </div>
              </div>
              <div className='col-sm-12 pb-3'>
                <div className='row'>
                  <div className='col-sm-6 text-center'>
                    <button id='loginWithGoogleButton' name='loginWithGoogleButton' className='btn btn-primary w-100'>Google</button>
                  </div>
                  <div className='col-sm-6 text-center'>
                    <button id='loginWithAppleButton' name='loginWithAppleButton' className='btn btn-primary w-100'>Apple</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignUp;